export default __webpack_public_path__ + "static/media/krbova-kamna.357c9c40.jpeg";